import e from"react";const t=({contentSection:t})=>e.createElement("div",null,e.createElement("div",null,e.createElement("div",{dangerouslySetInnerHTML:{__html:t}})));export{t as InteriorContentV2};
